import * as React from 'react'

import i18n from 'modules/core/lib/i18n'
import { NavigationRoutesFn } from 'modules/core/lib/react-router'

const RootPage = React.lazy(() => import('modules/engagement_surveys/pages/MySurveys/RootPage'))
const MySurveysListPage = React.lazy(
  () => import('modules/engagement_surveys/pages/MySurveys/MySurveysListPage')
)

export const mySurveysRoutes: NavigationRoutesFn = (navigation) => [
  {
    path: navigation.mySurveys.path,
    element: <RootPage />,
    handle: {
      module: 'my_surveys',
      moduleName: () => i18n.t('sidebar.my_surveys'),
    },
    children: [
      {
        index: true,
        element: <MySurveysListPage />,
      },
      {
        path: navigation.mySurveys.membershipId.path,
        element: <MySurveysListPage />,
      },
    ],
  },
]
